import type { CSSProperties } from 'react'

export interface SegmentedOption<T extends string> {
  value: T
  label: string
}

type Props<T extends string> = {
  options: ReadonlyArray<SegmentedOption<T>>
  value: T
  onChange: (next: T) => void
}

// The options read as chips from the main filter row (same height/border/radius
// as .filter-chip), but the selected one is filled with the accent so the active
// mode pops instead of fading into the panel. One control for every mode toggle
// across the app (Cashflow grains, Salary tabs, forecast week-count, …).
const wrapStyle: CSSProperties = {
  display: 'inline-flex',
  gap: 4,
}

const baseBtn: CSSProperties = {
  height: 26,
  padding: '0 12px',
  fontSize: 12,
  borderRadius: 'var(--radius-sm)',
  fontFamily: 'inherit',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background var(--dur-fast) var(--ease), border-color var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease)',
}

export function Segmented<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div style={wrapStyle}>
      {options.map((opt) => {
        const active = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            style={{
              ...baseBtn,
              fontWeight: active ? 600 : 500,
              background: active ? 'var(--accent)' : 'var(--bg-2)',
              color: active ? 'var(--accent-fg)' : 'var(--fg-2)',
              border: `1px solid ${active ? 'var(--accent)' : 'var(--border-default)'}`,
            }}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
